export const palette = {
  primary: '#5A7575',
  accent: '#A15D00',
  neutral: '#FDF6E3',
}
